<div class="mobile-list">
  @for (row of data(); track $index; let rowIndex = $index) {
    <div class="mobile-card" [class.mobile-card--expanded]="row.isOpen">

      <!-- Cabeçalho do card: colunas principais + controles -->
      <div class="mobile-card__header">
        <div class="mobile-card__content">
          @for (column of displayedColumns; track $index) {
            <div class="mobile-card__field" [class.mobile-card__field--primary]="$index === 0">
              <span class="mobile-card__label">{{ column.name | translate }}</span>
              <div class="mobile-card__value">
                <app-table-cell [column]="column" [row]="row"></app-table-cell>
              </div>
            </div>
          }
        </div>

        <div class="mobile-card__controls">
          @if (hidedColumns.length) {
            <button
              mat-icon-button
              class="mobile-card__expand-btn"
              (click)="row.isOpen = !row.isOpen"
              [matTooltip]="'COMMON.DETAILS' | translate"
            >
              <mat-icon [class.mobile-card__chevron--open]="row.isOpen">expand_more</mat-icon>
            </button>
          }
          <button mat-icon-button [matMenuTriggerFor]="actionsMenu" class="mobile-card__menu-btn">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #actionsMenu="matMenu" class="table-actions-menu">
            @for (action of actions(); track $index) {
              <button
                mat-menu-item
                (click)="onAction(action, row, rowIndex)"
                [disabled]="action.disabled ? action.disabled(row) : false"
              >
                <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                <span>{{ action.name | translate }}</span>
              </button>
            }
          </mat-menu>
        </div>
      </div>

      <!-- Conteúdo expandido -->
      @if (row.isOpen && hidedColumns.length) {
        <div class="mobile-card__expanded">
          @for (column of hidedColumns; track $index) {
            <div class="mobile-card__expanded-field">
              <span class="mobile-card__label">{{ column.name | translate }}</span>
              <div class="mobile-card__value">
                <app-table-cell [column]="column" [row]="row"></app-table-cell>
              </div>
            </div>
          }
        </div>
      }

    </div>
  }
</div>
